<template>
  <div>
    <notifications group="notification" position="bottom right" />

    <div v-if="categories.length > 0" class="row">
      <div class="col-md-12">
        <div class="card card-custom gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 py-5">
            <h3 class="card-title">
              <span class="card-label font-weight-bolder text-dark"
                >All Categories</span
              >
            </h3>
            <div class="card-toolbar">
              <router-link
                to="/products-categories/new"
                class="btn btn-mc font-weight-bolder font-size-sm"
              >
                <span class="svg-icon svg-icon-md svg-icon-white">
                  <inline-svg
                    src="media/svg/icons/Communication/Add-user.svg"
                  /> </span
                >Add New Category
              </router-link>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body py-0">
            <!--begin::Table-->
            <div class="table-responsive">
              <table
                class="table table-head-custom table-head-bg table-vertical-center"
              >
                <thead>
                  <tr class="text-left text-uppercase">
                    <th style="min-width: 120px" class="pl-6">Category</th>
                    <th style="min-width: 120px">Root category</th>
                    <th style="min-width: 110px" class="pr-6 text-right">
                      Actions
                    </th>
                  </tr>
                </thead>
                <draggable
                  v-model="filteredCategories"
                  @end="onEnd"
                  tag="tbody"
                  handle=".handle"
                >
                  <tr v-for="(category, key) in filteredCategories" :key="key">
                    <td class="pl-6" :class="{ 'border-top-0': key === 0 }">
                      <span v-if="category.root.title">-- </span>
                      <span v-else></span>
                      <router-link
                        :to="'/products-categories/edit/' + category.id"
                        class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                      >
                        <del v-if="category.isArchived">{{
                          category.title
                        }}</del>
                        <span v-else>{{ category.title }}</span>
                        <span
                          v-if="category.isArchived"
                          class="ml-2 label label-sm label-light-danger label-inline"
                          >Archived</span
                        >
                      </router-link>
                    </td>
                    <td :class="{ 'border-top-0': key === 0 }">
                      <span
                        v-if="category.root.title"
                        class="label label-lg label-light-primary label-inline"
                        >{{ category.root.title }}</span
                      >
                      <span
                        v-else
                        class="label label-lg label-light-danger label-inline"
                        >Root</span
                      >
                    </td>
                    <td class="pr-6 text-right">
                      <button
                        v-if="category.root.title"
                        class="btn btn-icon btn-light btn-hover-light-primary btn-sm mr-3 handle"
                      >
                        <span class="svg-icon svg-icon-md">
                          <inline-svg
                            src="media/svg/icons/Navigation/Up-down.svg"
                          />
                        </span>
                      </button>
                      <router-link
                        :to="'/products-categories/edit/' + category.id"
                        class="btn btn-icon btn-light btn-hover-light-primary btn-sm mr-3"
                      >
                        <span class="svg-icon svg-icon-md">
                          <inline-svg
                            src="media/svg/icons/Communication/Write.svg"
                          />
                        </span>
                      </router-link>
                      <button
                        @click="removeProductCategory(category.id)"
                        class="btn btn-icon btn-light btn-hover-light-primary btn-sm"
                      >
                        <span class="svg-icon svg-icon-md">
                          <inline-svg src="media/svg/icons/General/Trash.svg" />
                        </span>
                      </button>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
            <!--end::Table-->
          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-md-12 text-center">
        <b-spinner variant="primary" type="grow"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import ApiService from '@/core/services/api.service'
import draggable from 'vuedraggable'

export default {
  name: 'ListProductsCategories',
  components: {
    draggable,
  },
  data() {
    return {
      categories: [],
      parentCategories: [],
      childrenCategories: [],
      filteredCategories: [],
      totalItems: null,
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Categories', route: '/products-categories/list' },
    ])

    ApiService.get(
      `/product_categories`,
      `?order[createdAt]=desc&order[position]=asc&itemsPerPage=90`
    ).then(({ data }) => {
      this.totalItems = data['hydra:totalItems']
      this.categories = [...data['hydra:member']]

      this.parentCategories = this.categories.filter(
        (category) => category.parent === undefined
      )
      this.childrenCategories = this.categories.filter(
        (category) => category.parent !== undefined
      )

      this.parentCategories.forEach((parentCategory) => {
        this.filteredCategories.push(parentCategory)
        this.childrenCategories.forEach((childrenCategory) => {
          if (childrenCategory.root['@id'] === parentCategory.root) {
            this.filteredCategories.push(childrenCategory)
          }
        })
      })

      // console.log('filteredCategories', this.filteredCategories)
    })
  },
  methods: {
    async deleteProductCategory(id) {
      try {
        return await ApiService.delete('/product_categories/' + id)
      } catch (e) {
        throw new Error(e)
      }
    },
    removeProductCategory(id) {
      const confirmation = confirm('You want delete this category?')
      if (confirmation === false) return

      this.deleteProductCategory(id).then(({ status }) => {
        if (status === 204) {
          this.$notify({
            group: 'notification',
            type: 'error',
            title: 'Category success deleted from database',
          })
        }
      })
    },
    onEnd() {},
  },
}
</script>
